import React from 'react';
import PropTypes from 'prop-types';
import ModalAction from '../../../components/ModalAction';

function DeleteCustomerModal(props) {
  const { modalOpen, setModalOpen, customerData, onConfirm, isLoading } = props;

  return (
    <ModalAction
      id="delete-customer-modal"
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
    >
      <div className="p-6 text-center">
        {/* Icon */}
        <div className="mb-6 flex items-center justify-center">
          <div className="w-16 h-16 rounded-full bg-red-50 dark:bg-red-500/10 flex items-center justify-center ring-8 ring-red-50 dark:ring-red-500/5">
            <svg
              className="w-8 h-8 text-red-500"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="mb-8">
          <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">
            Delete Customer
          </h3>
          <div className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed max-w-sm mx-auto">
            <p className="mb-4">
              Are you sure you want to delete{' '}
              <span className="font-semibold text-gray-900 dark:text-white break-words">
                &quot;{customerData?.fullName || 'this customer'}&quot;
              </span>
              ?
            </p>
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-900/30 rounded-lg p-3">
              <div className="flex items-center justify-center gap-2 text-red-800 dark:text-red-200 font-medium text-xs sm:text-sm">
                <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                <span>This action cannot be undone.</span>
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col-reverse sm:flex-row sm:justify-center gap-3 w-full">
          <button
            className="btn w-full sm:w-1/2 bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 text-gray-700 dark:text-gray-300 transition-colors shadow-sm"
            onClick={e => {
              e.stopPropagation();
              setModalOpen(false);
            }}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="btn w-full sm:w-1/2 bg-red-600 hover:bg-red-700 text-white shadow-sm shadow-red-500/30 transition-all flex items-center justify-center gap-2"
            onClick={e => {
              e.stopPropagation();
              onConfirm();
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <svg
                  className="animate-spin h-4 w-4 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>Deleting...</span>
              </>
            ) : (
              'Delete Customer'
            )}
          </button>
        </div>
      </div>
    </ModalAction>
  );
}

DeleteCustomerModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  customerData: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default DeleteCustomerModal;
